"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var React = require("react");
var user_1 = require("~/js/lib/user/user");
var theme_1 = require("~@/widget/theme/theme");
require("./right-follow.scss");
var util_1 = require("src/js/lib/util/util");
var ANCHOR_DATA_LIMIT = 7;
var FETCH_INTERVAL = 300;
var ETabType;
(function (ETabType) {
    ETabType["ANCHOR"] = "anchor";
    ETabType["SUBSCRIPTION"] = "subscription";
    ETabType["MEDIA"] = "media";
})(ETabType || (ETabType = {}));
function timeFormat(timestamp) {
    var time = new Date(timestamp);
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var day = time.getDate();
    var hour = time.getHours();
    var minute = time.getMinutes();
    var showTime = { day: '', time: '' };
    var today = this.getDateAssignDay(0).year +
        this.getDateAssignDay(0).month +
        this.getDateAssignDay(0).day;
    var tomorrow = this.getDateAssignDay(1).year +
        this.getDateAssignDay(1).month +
        this.getDateAssignDay(1).day;
    if (showTime.day === today) {
        showTime.day = '今天';
    }
    else if (showTime.day === tomorrow) {
        showTime.day = '明天';
    }
    else {
        showTime.day = (month < 10 ? '0' + month : month) + '月' + (day < 10 ? '0' + day : day) + '日';
    }
    showTime.time = (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute);
    return showTime;
}
var RightFollow = (function (_super) {
    __extends(RightFollow, _super);
    function RightFollow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isHover: false,
            tabs: (function () {
                if (props.themeInfo.type === 'yue') {
                    return [
                        { text: '主播', key: ETabType.ANCHOR },
                        { text: '节目', key: ETabType.SUBSCRIPTION },
                        { text: '媒体', key: ETabType.MEDIA }
                    ];
                }
                else {
                    return [
                        { text: '订阅主播', key: ETabType.ANCHOR },
                        { text: '订阅节目', key: ETabType.SUBSCRIPTION }
                    ];
                }
            })(),
            curTab: ETabType.ANCHOR,
            attDatas: [],
            attLoading: true,
            subDatas: [],
            subLoading: true,
            mediaDatas: [],
            mediaLoading: true
        };
        _this.fetchData = util_1.debounce(function (type) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (type) {
                    case ETabType.ANCHOR:
                        return [2, this.fetchFollow()];
                    case ETabType.SUBSCRIPTION:
                        return [2, this.fetchFollow()];
                    case ETabType.MEDIA:
                        return [2, this.fetchMedia()];
                }
                return [2];
            });
        }); }, FETCH_INTERVAL);
        return _this;
    }
    RightFollow.prototype.render = function () {
        var _this = this;
        var _a = this.state, isHover = _a.isHover, tabs = _a.tabs, curTab = _a.curTab, attDatas = _a.attDatas, subDatas = _a.subDatas, mediaDatas = _a.mediaDatas, attLoading = _a.attLoading, subLoading = _a.subLoading, mediaLoading = _a.mediaLoading;
        var isLogined = this.props.isLogined;
        var themeInfo = this.props.themeInfo;
        return (React.createElement("div", { className: "p-header__main__cnt__right__item p-header__main__cnt__right__item--focus", onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this) },
            React.createElement("a", { className: "p-header__main__cnt__right__item__tl", href: "javascript:;" },
                React.createElement("i", { className: "p-header__main__cnt__right__item__tl__icon" }),
                React.createElement("span", { className: "p-header__main__cnt__right__item__tl__t" }, "\u8BA2\u9605")),
            React.createElement("div", { className: "p-header__drag " + (isHover ? 'p-header__drag--show' : '') },
                React.createElement("span", { className: "p-header__drag__enterstage" },
                    React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                    React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
                React.createElement("div", { className: "p-header__drag__main" },
                    !isLogined && (React.createElement("div", { className: "p-header__focus" },
                        React.createElement("div", { className: "p-header__blank" },
                            React.createElement("span", { className: "p-header__blank__t" }, "\u767B\u5F55\u540E\u53EF\u540C\u6B65\u8BA2\u9605\u54E6~")),
                        React.createElement("div", { className: "p-header__loginbtn" },
                            React.createElement("a", { className: "p-header__loginbtn__link", href: "javascript:;", onClick: function () { return user_1.showYYLoginBox(); } }, "\u767B\u5F55")))),
                    isLogined && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "p-header__tabs" },
                            React.createElement("ul", { className: "p-header__tabs__hd" }, tabs.map(function (item, index) {
                                return (React.createElement("li", { key: index, className: "p-header__tabs__hd__item " + (tabs.length === 3 ? 'p-header__tabs__hd__item--third' : '') + " " + (curTab === item.key ? 'p-header__tabs__hd__item--current' : ''), onMouseEnter: _this.onSwitchTab.bind(_this, item.key) },
                                    React.createElement("span", { className: "p-header__tabs__hd__item__t" }, item.text)));
                            }))),
                        React.createElement("div", { className: "p-header__tabs__bd " + (curTab === ETabType.ANCHOR ? 'p-header__tabs__bd--current' : '') + " " + (attLoading ? 'p-header__tabs__bd--loading' : '') },
                            React.createElement("div", { className: "p-header__loading" },
                                React.createElement("i", { className: "p-header__loading__icon" })),
                            React.createElement("div", { className: "p-header__focus__cnt" },
                                attDatas.length === 0 && (React.createElement("div", { className: "p-header__blank" },
                                    React.createElement("span", { className: "p-header__blank__t" }, "\u4F60\u8FD8\u6CA1\u6709\u8BA2\u9605\u4EFB\u4F55\u4E3B\u64AD"))),
                                attDatas.length !== 0 && (React.createElement("div", { className: "p-header__focus__att__list" },
                                    React.createElement("ul", null, attDatas.map(function (item, index) {
                                        return (React.createElement("li", { key: index, className: "p-header__focus__att__list__item " + (item.isLive ? 'isliving' : '') },
                                            React.createElement("a", { className: "p-header__focus__att__list__item__box", href: item.link },
                                                React.createElement("span", { className: "p-header__focus__att__list__item__box__cover" },
                                                    React.createElement("img", { className: "p-header__focus__att__list__item__box__cover__img", src: item.cover, width: "40", height: "40", alt: item.title })),
                                                React.createElement("span", { className: "p-header__focus__att__list__item__box__s1" }, item.author),
                                                React.createElement("span", { className: "p-header__focus__att__list__item__box__usr" },
                                                    React.createElement("i", { className: "p-header__focus__att__list__item__box__usr__icon" }),
                                                    React.createElement("span", { className: "p-header__focus__att__list__item__box__usr__t" }, item.hot)),
                                                React.createElement("i", { className: "p-header__focus__att__list__item__box__icon-live" }))));
                                    })))))),
                        React.createElement("div", { className: "p-header__tabs__bd " + (curTab === ETabType.SUBSCRIPTION ? 'p-header__tabs__bd--current' : '') + " " + (subLoading ? 'p-header__tabs__bd--loading' : '') },
                            React.createElement("div", { className: "p-header__loading" },
                                React.createElement("i", { className: "p-header__loading__icon" })),
                            React.createElement("div", { className: "p-header__focus__cnt" },
                                subDatas.length === 0 && (React.createElement("div", { className: "p-header__blank" },
                                    React.createElement("span", { className: "p-header__blank__t" }, "\u4F60\u8FD8\u6CA1\u6709\u8BA2\u9605\u4EFB\u4F55\u8282\u76EE"))),
                                subDatas.length !== 0 && (React.createElement("div", { className: "p-header__focus__sub__list" }, subDatas.map(function (item, index) {
                                    return (React.createElement(React.Fragment, { key: index },
                                        React.createElement("div", { className: "p-header__focus__sub__list__predict-time" },
                                            React.createElement("i", { className: "p-header__focus__sub__list__predict-time__icon" }),
                                            React.createElement("span", { className: "p-header__focus__sub__list__predict-time__t" }, item.date)),
                                        React.createElement("ul", { className: "p-header__focus__sub__list__ul" }, item.items.map(function (subItem, i) {
                                            return (React.createElement("li", { key: i, className: "p-header__focus__sub__list__ul__item " + (subItem.isLive ? 'isliving' : '') },
                                                React.createElement("a", { className: "p-header__focus__sub__list__ul__item__box", href: subItem.link },
                                                    React.createElement("span", { className: "p-header__focus__sub__list__ul__item__box__s1" },
                                                        React.createElement("i", { className: "p-header__focus__sub__list__ul__item__box__s1__time" }, subItem.timeName),
                                                        React.createElement("span", { className: "p-header__focus__sub__list__ul__item__box__s1__txt" }, subItem.title),
                                                        React.createElement("i", { className: "p-header__focus__sub__list__ul__item__box__icon-live" })))));
                                        }))));
                                }))),
                                React.createElement("div", { className: "p-header__more" },
                                    isLogined && (React.createElement("a", { className: "p-header__more__link", href: "https://www.yy.com/i/index/anchor", target: "_blank" }, "\u67E5\u770B\u66F4\u591A >")),
                                    !isLogined && (React.createElement("a", { className: "p-header__more__link", href: "javascript:;", onClick: function () { return user_1.showYYLoginBox(); } }, "\u67E5\u770B\u66F4\u591A >"))))),
                        React.createElement("div", { className: "p-header__tabs__bd " + (curTab === ETabType.MEDIA ? 'p-header__tabs__bd--current' : '') + " " + (mediaLoading ? 'p-header__tabs__bd--loading' : '') },
                            React.createElement("div", { className: "p-header__loading" },
                                React.createElement("i", { className: "p-header__loading__icon" })),
                            React.createElement("div", { className: "p-header__focus__cnt" },
                                !mediaDatas.length && (React.createElement("div", { className: "p-header__blank" },
                                    React.createElement("span", { className: "p-header__blank__t" }, "\u4F60\u8FD8\u6CA1\u6709\u8BA2\u9605\u4EFB\u4F55\u5A92\u4F53"))),
                                mediaDatas.length && (React.createElement("div", { className: "p-header__focus__med__list" },
                                    React.createElement("ul", { className: "p-header__focus__med__list__ul" }, mediaDatas.map(function (item, index) {
                                        return (React.createElement("li", { key: index, className: "p-header__focus__med__list__ul__item" },
                                            React.createElement("a", { className: "p-header__focus__med__list__ul__item__box", href: item.link, target: "_blank" },
                                                React.createElement("span", { className: "p-header__focus__med__list__ul__item__box__cover" },
                                                    React.createElement("img", { className: "p-header__focus__med__list__ul__item__box__cover__img", src: item.headImg, width: "30", height: "30", alt: item.publisherName })),
                                                React.createElement("span", { className: "p-header__focus__med__list__ul__item__box__info" },
                                                    React.createElement("span", { className: "p-header__focus__med__list__ul__item__box__info__tl" }, item.publisherName),
                                                    React.createElement("span", { className: "p-header__focus__med__list__ul__item__box__info__pub" },
                                                        item.pubMsgNum,
                                                        "\u4E2A\u53D1\u5E03")))));
                                    }))))))))))));
    };
    RightFollow.prototype.componentWillUpdate = function (nextProps) {
        var _this = this;
        var isLogined = this.props.isLogined;
        var _a = this.state, isHover = _a.isHover, curTab = _a.curTab;
        if (isLogined !== nextProps.isLogined) {
            this.setState({
                attDatas: [],
                attLoading: true,
                subDatas: [],
                subLoading: true,
                mediaDatas: [],
                mediaLoading: true
            }, function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(isHover && isLogined)) return [3, 2];
                            return [4, this.fetchData(curTab)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2];
                    }
                });
            }); });
        }
    };
    RightFollow.prototype.onMouseEnter = function () {
        this.setState({
            isHover: true
        });
        var _a = this.state, curTab = _a.curTab, attLoading = _a.attLoading;
        this.fetchData(curTab);
    };
    RightFollow.prototype.onMouseLeave = function () {
        this.setState({
            isHover: false
        });
    };
    RightFollow.prototype.onSwitchTab = function (tab) {
        var _this = this;
        var _a = this.state, curTab = _a.curTab, attLoading = _a.attLoading;
        if (curTab !== tab || (curTab === ETabType.ANCHOR && attLoading)) {
            this.setState({
                curTab: tab
            }, function () {
                _this.fetchData(tab);
            });
        }
    };
    RightFollow.prototype.fetchFollow = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err, data, attDatas, subDatas;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, user_1.fetchMyFollow()];
                    case 1:
                        _a = _b.sent(), err = _a[0], data = _a[1];
                        attDatas = [];
                        if (data.att && data.att.length) {
                            data.att.slice(0, ANCHOR_DATA_LIMIT).forEach(function (item) {
                                var iCover = item.anchorInfo.logo || item.anchorInfo.hdLogo || item.liveCover || theme_1.DEFAULT_AVATAR;
                                attDatas.push({
                                    isLive: item.liveUrl ? true : false,
                                    link: "" + theme_1.DOMAIN + (item.liveUrl ? item.liveUrl : "/u/" + item.anchorInfo.yynum),
                                    cover: util_1.convertHttps(iCover),
                                    author: item.anchorInfo.nick || '未知',
                                    hot: util_1.moneyFormat(item.users),
                                    title: item.anchorInfo.nick || item.title
                                });
                            });
                        }
                        subDatas = [];
                        if (data.sub && data.sub.length) {
                            data.sub.forEach(function (item) {
                                var showTime = timeFormat(item.predictTime);
                                var lastSubItem = subDatas[subDatas.length - 1];
                                if (!lastSubItem || lastSubItem.date !== showTime.day) {
                                    var rItem = {
                                        date: showTime.day,
                                        items: []
                                    };
                                    subDatas.push(rItem);
                                    lastSubItem = rItem;
                                }
                                var rCellItem = {
                                    isToday: showTime.day === '今天',
                                    isLive: item.liveStatus === 2,
                                    link: item.liveUrl ? "" + theme_1.DOMAIN + item.liveUrl : '###',
                                    timeName: showTime.time,
                                    title: item.title
                                };
                                lastSubItem.items.push(rCellItem);
                            });
                        }
                        this.setState({
                            attDatas: attDatas,
                            attLoading: false,
                            subDatas: subDatas,
                            subLoading: false
                        });
                        return [2];
                }
            });
        });
    };
    RightFollow.prototype.fetchMedia = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, err, data, mediaDatas;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, user_1.fetchMyMedia()];
                    case 1:
                        _a = _b.sent(), err = _a[0], data = _a[1];
                        mediaDatas = [];
                        if (data) {
                            data.forEach(function (item) {
                                mediaDatas.push({
                                    publisherName: item.publisherName,
                                    id: item.id,
                                    pubMsgNum: item.pubMsgNum,
                                    headImg: item.headImg,
                                    link: theme_1.DOMAIN + "/yue/publisher?id=" + item.id
                                });
                            });
                        }
                        this.setState({
                            mediaDatas: mediaDatas,
                            mediaLoading: false
                        });
                        return [2];
                }
            });
        });
    };
    return RightFollow;
}(React.Component));
exports.RightFollow = RightFollow;
